module.exports = __webpack_public_path__ + "img/logo_blanco.3c9104ca.png";